import React from 'react';
import itemIdValue from '../../../itemIdValue';
import useLabel from '../../utils/Translations/useLabel';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import ApprovalStatuses from '../../../../model/ApprovalStatuses';
import MultiselectFilter from './MultiselectFilter';
const ApprovalStatusSelector = ({ title, ...props }) => {
    const _title = useLabel('Approval Status', title);
    const { options } = useEnumerableModel(ApprovalStatuses);
    return (<MultiselectFilter itemId={itemIdValue} options={options} title={_title} {...props}/>);
};
export default ApprovalStatusSelector;
